<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <!--            <a-col :md="6" :sm="24">
                          <a-form-item :label="$t('通用.文本.创建开始时间')" prop="createBeginTime">
                            <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                                 :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                                 valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                          </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                          <a-form-item :label="$t('通用.文本.创建结束时间')" prop="createEndTime">
                            <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                                 :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                                 valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                          </a-form-item>
                        </a-col>-->
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('商品评价.评价内容')" prop="content">
                <a-input v-model="queryParam.content" :placeholder="$t('通用.输入.请输入')+$t('商品评价.评价内容')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons"
                    :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search"/>{{ $t('通用.按钮.查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon
                  type="redo"/>{{ $t('通用.按钮.重置') }}</a-button>
                <!--                <a @click="toggleAdvanced" style="margin-left: 8px">
                                  {{ advanced ? $t('通用.按钮.收起') : $t('通用.按钮.展开') }}
                                  <a-icon :type="advanced ? 'up' : 'down'"/>
                                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl"/>
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['goods:evaluate:add']">
                  <a-icon type="plus" />{{$t('通用.按钮.新增')}}
                </a-button>-->
        <!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['goods:evaluate:edit']">
                  <a-icon type="edit" />{{$t('通用.按钮.修改')}}
                </a-button>-->
        <a-button type="danger" :disabled="multiple" @click="handleDelete" >
          <a-icon type="delete"/>
          {{ $t('通用.按钮.删除') }}
        </a-button>
        <!--        <a-button type="primary" @click="handleExport" v-hasPermi="['goods:evaluate:export']">
                  <a-icon type="download" />{{$t('通用.按钮.导出')}}
                </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"/>
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="againAddtime" slot-scope="text, record">
          {{ parseTime(record.againAddtime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
         <!--   <a-divider type="vertical" v-hasPermi="['goods:evaluate:edit']" />
         <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['goods:evaluate:edit']">
             <a-icon type="edit" />{{$t('通用.按钮.修改')}}
          </a>-->
          <a-divider type="vertical"/>
          <a @click="handleDelete(record)" >
            <a-icon type="delete"/>{{ $t('通用.按钮.删除') }}
          </a>
        </span>
        <template slot="goodsImage" slot-scope="text, record">
          <div>
            <img v-if="record.goodsImage" :src="record.goodsImage" style="width:60px;height:62px;"
                 @click="handleRecordPreview(record.goodsImage)" alt="none"/>
          </div>
        </template>
        <template slot="image" slot-scope="text, record">
          <div>
            <img v-if="record.image" :src="record.image" style="width:60px;height:62px;"
                 @click="handleRecordPreview(record.image)" alt="none"/>
          </div>
        </template>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {pageEvaluate, listEvaluate, delEvaluate} from '@/api/goods/evaluate'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import {tableMixin} from '@/store/table-mixin'

export default {
  name: 'Evaluate',
  components: {
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        pid: undefined,
        orderId: undefined,
        orderNo: undefined,
        orderGoodsId: undefined,
        goodsId: undefined,
        goodsCode: undefined,
        goodsName: undefined,
        goodsPrice: undefined,
        goodsImage: undefined,
        skuName: undefined,
        shopId: undefined,
        shopName: undefined,
        goodsType: undefined,
        content: undefined,
        image: undefined,
        explainFirst: undefined,
        memberName: undefined,
        number: undefined,
        userId: undefined,
        avatar: undefined,
        isAnonymous: undefined,
        evaluateScores: undefined,
        qualityScores: undefined,
        serviceScores: undefined,
        againContent: undefined,
        againImage: undefined,
        againExplain: undefined,
        explainType: undefined,
        isShow: undefined,
        againAddtime: undefined,
        videoUrl: undefined,
        type: undefined,
        coverImage: undefined,
        faceTo: undefined,
        pushTop: undefined,
        inventEvaluate: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        /*{
          title: this.$t('商品评价.评价ID'),
          dataIndex: 'id',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商品评价.上级id'),
          dataIndex: 'pid',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商品评价.订单ID'),
          dataIndex: 'orderId',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商品评价.订单编号'),
          dataIndex: 'orderNo',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商品评价.订单项ID'),
          dataIndex: 'orderGoodsId',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: this.$t('商品评价.商品ID'),
          dataIndex: 'goodsId',
          ellipsis: true,
          width: 200,
          align: 'center'
        },
        {
          title: this.$t('商品评价.商品名称'),
          dataIndex: 'goodsName',
          width: 300,
          ellipsis: true,
          align: 'center'
        },
        /*{
          title: this.$t('商品评价.商品价格'),
          dataIndex: 'goodsPrice',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: this.$t('商品评价.商品图片'),
          dataIndex: 'goodsImage',
          ellipsis: true,
          width: 100,
          scopedSlots: {customRender: 'goodsImage'},
          align: 'center'
        },
        /*{
          title: this.$t('商品评价.规格名称'),
          dataIndex: 'skuName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商品评价.店铺ID'),
          dataIndex: 'shopId',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商品评价.店铺名称'),
          dataIndex: 'shopName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商品评价.是否自营  0：否 1：是'),
          dataIndex: 'goodsType',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: this.$t('商品评价.评价内容'),
          dataIndex: 'content',
          width: 300,
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商品评价.评价图片'),
          dataIndex: 'image',
          ellipsis: true,
          width: 100,
          scopedSlots: {customRender: 'image'},
          align: 'center'
        },
        /*{
          title: this.$t('商品评价.解释内容'),
          dataIndex: 'explainFirst',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商品评价.评价人名称'),
          dataIndex: 'memberName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商品评价.点赞数量'),
          dataIndex: 'number',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商品评价.评价人编号'),
          dataIndex: 'userId',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商品评价.头像'),
          dataIndex: 'avatar',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商品评价.0表示不是 1表示是匿名评价'),
          dataIndex: 'isAnonymous',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商品评价.评价星级'),
          dataIndex: 'evaluateScores',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商品评价.物流服务'),
          dataIndex: 'qualityScores',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: this.$t('商品评价.服务评分'),
          dataIndex: 'evaluateScores',
          width: 100,
          ellipsis: true,
          align: 'center'
        },
        /* {
           title: this.$t('商品评价.追加评价内容'),
           dataIndex: 'againContent',
           ellipsis: true,
           align: 'center'
         },
         {
           title: this.$t('商品评价.追加评价图片'),
           dataIndex: 'againImage',
           ellipsis: true,
           align: 'center'
         },
         {
           title: this.$t('商品评价.追加解释内容'),
           dataIndex: 'againExplain',
           ellipsis: true,
           align: 'center'
         },
         {
           title: this.$t('商品评价.1好评2中评3差评'),
           dataIndex: 'explainType',
           ellipsis: true,
           align: 'center'
         },*/
        /*{
          title: this.$t('商品评价.1显示 0隐藏'),
          dataIndex: 'isShow',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商品评价.追加评价时间'),
          dataIndex: 'againAddtime',
          scopedSlots: { customRender: 'againAddtime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商品评价.评价视频'),
          dataIndex: 'videoUrl',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商品评价.评价类型.0:文字；1:图片；2:视频'),
          dataIndex: 'type',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商品评价.视频封面图'),
          dataIndex: 'coverImage',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商品评价.评价面向：0商品，1店铺'),
          dataIndex: 'faceTo',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商品评价.置顶：0、未置顶   1、置顶'),
          dataIndex: 'pushTop',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('商品评价.是否虚拟评价：0、普通用户   1、虚拟用户'),
          dataIndex: 'inventEvaluate',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: this.$t('商品评价.创建时间'),
          dataIndex: 'createTime',
          scopedSlots: {customRender: 'createTime'},
          ellipsis: true,
          align: 'center'
        },
        /*{
          title: this.$t('商品评价.备注'),
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: {customRender: 'operation'},
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  methods: {
    moment,
    getTotal(total) {
      return this.$t('通用.文本.共') + total + this.$t('通用.文本.条')
    },
    /** 查询商品评价列表 */
    getList() {
      this.loading = true
      pageEvaluate(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pid: undefined,
        orderId: undefined,
        orderNo: undefined,
        orderGoodsId: undefined,
        goodsId: undefined,
        goodsCode: undefined,
        goodsName: undefined,
        goodsPrice: undefined,
        goodsImage: undefined,
        skuName: undefined,
        shopId: undefined,
        shopName: undefined,
        goodsType: undefined,
        content: undefined,
        image: undefined,
        explainFirst: undefined,
        memberName: undefined,
        number: undefined,
        userId: undefined,
        avatar: undefined,
        isAnonymous: undefined,
        evaluateScores: undefined,
        qualityScores: undefined,
        serviceScores: undefined,
        againContent: undefined,
        againImage: undefined,
        againExplain: undefined,
        explainType: undefined,
        isShow: undefined,
        againAddtime: undefined,
        videoUrl: undefined,
        type: undefined,
        coverImage: undefined,
        faceTo: undefined,
        pushTop: undefined,
        inventEvaluate: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField === 'createTime') {
          this.queryParam.sortField = 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk() {
          let data = []
          that.ids.map(id => data.push({"id": id}))
          return delEvaluate(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('通用.文本.删除成功')
              that.$message.success(
                message,
                3
              )
            })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出当前条件下所有数据而非选中数据'),
        onOk() {
          that.download('goods/evaluate/export',
            ...that.queryParam
            , `商品评价_${new Date().getTime()}.xlsx`)
        },
        onCancel() {
        }
      })
    }
  }
}
</script>
